import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { TextField } from '../../../ui/FormElement';

function NumberEmployeesFiels(props) {
  const { isDisabled, ...rest } = props;
  const {
    values: { cover_everybody, total_employees, rules },
    setFieldValue,
  } = useFormikContext();

  useEffect(() => {
    if (cover_everybody) {
      if (total_employees == '') {
        setFieldValue('employees_covered', total_employees);
      }
    }
  }, [cover_everybody]);

  const employeeMinimalRule = rules ? rules.find((item) => item.type === 'employee_minimal') : null;

  return (
    <TextField
      disabled={isDisabled}
      name="employees_covered"
      type="number"
      min="0"
      step="1"
      pattern="[0-9]*"
      hint={employeeMinimalRule ? `Employee Minimum: ${employeeMinimalRule.value}` : ''}
      {...rest}
    />

  );
}

export default NumberEmployeesFiels;
